import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"

export const FETCH_LOCATIONS_BEGIN = "FETCH_LOCATIONS_BEGIN"
export const FETCH_LOCATIONS_SUCCESS = "FETCH_LOCATIONS_SUCCESS"
export const FETCH_LOCATIONS_ERROR = "FETCH_LOCATIONS_ERROR"
export const FETCH_LOCATIONS_RESET = "FETCH_LOCATIONS_RESET"

export const fetchLocationsBegin = () => ({
	type: FETCH_LOCATIONS_BEGIN,
})

export const fetchLocationsSuccess = (locationFiches) => ({
	type: FETCH_LOCATIONS_SUCCESS,
	payload: { locationFiches },
})

export const fetchLocationsError = (error) => ({
	type: FETCH_LOCATIONS_ERROR,
	payload: { error },
})

export const fetchLocationsReset = () => ({
	type: FETCH_LOCATIONS_RESET,
})

// Mémorise les critères saisis : préremplissage du formulaire au retour et
// re-recherche serveur après suppression. Calqué sur setAtelierSearchCriteres.
export const SET_LOCATION_SEARCH_CRITERES = "SET_LOCATION_SEARCH_CRITERES"
export const SET_LOCATION_SEARCH_RESULTS = "SET_LOCATION_SEARCH_RESULTS"

export const setLocationSearchCriteres = (criteres) => ({
	type: SET_LOCATION_SEARCH_CRITERES,
	payload: { criteres },
})

// Remplace la liste de résultats (le tri de la page résultats la réécrit pour
// que ordre affiché == ordre redux == ordre de feuilletage Page Up/Down).
export const setLocationSearchResults = (locationFiches) => ({
	type: SET_LOCATION_SEARCH_RESULTS,
	payload: { locationFiches },
})

// Renvoie le json pour permettre `.then((json) => json && history.push(...))`
// (recherche en 2 pages : formulaire → résultats).
export function fetchLocations(kwargs) {
	let url = `${URL}api/locations?`
	for (let kwarg in kwargs) url += `${kwarg}=${kwargs[kwarg]}&`
	url = url.substr(0, url.length - 1)
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchLocationsBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchLocationsSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, fetchLocationsError))
	}
}

// DELETE_LOCATION

export const DELETE_LOCATION_BEGIN = "DELETE_LOCATION_BEGIN"
export const DELETE_LOCATION_SUCCESS = "DELETE_LOCATION_SUCCESS"
export const DELETE_LOCATION_ERROR = "DELETE_LOCATION_ERROR"
export const DELETE_LOCATION_RESET = "DELETE_LOCATION_RESET"

export const deleteLocationBegin = (ticket) => ({
	type: DELETE_LOCATION_BEGIN,
	payload: { ticket },
})

export const deleteLocationSuccess = (locationFiches, ticket, id, relance) => ({
	type: DELETE_LOCATION_SUCCESS,
	payload: { locationFiches, ticket, id, relance },
})

export const deleteLocationError = (error, ticket) => ({
	type: DELETE_LOCATION_ERROR,
	payload: { error, ticket },
})

export const deleteLocationReset = () => ({
	type: DELETE_LOCATION_RESET,
})

// Ticket de chaque suppression : une réponse arrivée après un RESET (page
// quittée en pleine suppression, autre fiche ouverte depuis) ne s'affiche
// pas dans le modal d'une autre fiche — seule la ligne supprimée quitte la
// liste (reducer).
let ticketSuppression = 0

// silent : l'erreur s'affiche dans ResultDeleteModal (règle hybride).
export function deleteLocation(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		const ticket = ++ticketSuppression
		// Sans `search`, le DELETE ne relance rien (réponse []) : le reducer
		// retire alors la ligne au lieu de vider la liste.
		const { id, search } = JSON.parse(kwargs)
		const relance = search !== undefined && search !== null
		dispatch(deleteLocationBegin(ticket))
		return fetch(`${URL}api/locations`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: kwargs,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) =>
				dispatch(deleteLocationSuccess(json, ticket, id, relance)),
			)
			.catch(
				catchApiError(
					dispatch,
					(error) => deleteLocationError(error, ticket),
					{ silent: true },
				),
			)
	}
}
